import { graphql } from "gql";

const INTERNAL_ADMIN_USER_LIST_QUERY = graphql(`
  query InternalAdminUserList(
    $organizationId: ID!
    $input: InternalAdminUserListInput!
  ) {
    internalAdminUserList(organizationId: $organizationId, input: $input) {
      ...InternalAdminUser
    }
  }
`);

export default INTERNAL_ADMIN_USER_LIST_QUERY;
